import UserStore from '../stores/UserStore';

export const getCurrentUser = () => {
    const { user } = UserStore;

    return {
        data: user,
    };
};
